/**
 * Module types that can be enabled for entities
 */
export const MODULE_TYPES = {
  REBATES: "rebates",
} as const;

export type ModuleType = (typeof MODULE_TYPES)[keyof typeof MODULE_TYPES];

/**
 * Entity types that can have modules enabled
 */
export const ENTITY_TYPES = {
  AP_SUPPLIER: "ap_supplier",
  COMPANY: "company",
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];
